import React, { useState, useEffect } from "react";
import {
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
  sunsetDetailDataState,
} from "./SunsetSubs";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import CalendarModal from "../../../../Modal/CalendarModal";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import dayjs from "dayjs";

export default function SunriseDate() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );
  const [sunriseDate, setSunriseDate] = useState(
    location?.state
      ? dayjs(
          location?.state?.sunsetData?.sriseDate ??
            dayjs(
              dayjs(location?.state?.sunsetData?.ssetDate).add(1, "d")
            ).format("YYYY-MM-DD")
        ).format("YYYY-MM-DD")
      : "날짜 선택"
  );
  const [sunsetDateClick, setSunsetDateClick] = useState(false);

  useEffect(() => {
    if (sunriseDate !== "날짜 선택") {
      setSunsetDetailData({
        ...sunsetDetailData,
        sunriseDate,
      });
    }
  }, [sunriseDate]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>정책 변경일 (srise_date)</VerticalTableLabel>

      <LineBoxContainer>
        {buttonType === "view" ? (
          <VerticalTableValue>{sunriseDate}</VerticalTableValue>
        ) : (
          <CalendarLineBtn
            onClickEvent={() => setSunsetDateClick(true)}
            value={sunriseDate}
            initValue={"날짜 선택"}
            minWidth={220}
            disabled={sunsetDetailData?.sunsetDate === ""}
          />
        )}

        {sunsetDateClick && (
          <CalendarModal
            closeEvent={() => setSunsetDateClick(false)}
            changeEvent={(date: string) => setSunriseDate(date)}
            dateValue={sunsetDetailData?.sunsetDate}
            sPosition="absolute"
          />
        )}
      </LineBoxContainer>
    </VerticalTableRow>
  );
}
